import analytics from '@/shared-utils/analytics'

const createHandlers = (url: string, index: string) => {
  const handler = () => {
    analytics.fireGA4Event({
      event: 'select_promotion',
      attributes: {
        type: 'marketing',
        bundle_flag: 'y',
        bundle_type: '',
        product_name: 'bundle',
        promotion_name: 'bundle',
        creative_name: 'package_promo',
        items: [
          {
            index,
            item_name: 'bundle',
            item_id: 'actionCard'
          }
        ]
      }
    })
    window.open(url)
  }
  return {
    onClick: handler,
    handleSubmitCTA: handler
  }
}

export default [
  {
    imageUrl:
      'https://s1.pclncdn.com/design-assets/next-landing/assets/images/destinations/popular/vegas.jpeg?opto&auto=avif,webp',
    imageAlt: 'Hotels Tonight',
    heading: 'Limited time deals to Las Vegas',
    caption: 'Save big on your trip when you bundle',
    actionText: 'Book now',
    ...createHandlers(
      'https://www.priceline.com/partner/v2/packages-lasvegas',
      '1'
    )
  },
  {
    imageUrl:
      'https://s1.pclncdn.com/design-assets/next-landing/assets/images/destinations/popular/cancun.png?opto&auto=avif,webp',
    imageAlt: 'Hotels Tonight',
    heading: 'Limited time deals to Mexico and the Caribbean',
    caption: 'Save big on your trip when you bundle',
    actionText: 'Book now',
    ...createHandlers(
      'https://www.priceline.com/partner/v2/mexico-caribbean-packages',
      '2'
    )
  },
  {
    imageUrl:
      'https://s1.pclncdn.com/design-assets/next-landing/assets/images/destinations/popular/florida.png?opto&auto=avif,webp',
    imageAlt: 'Hotels Tonight',
    heading: 'Limited time deals to Florida',
    caption: 'Save big on your trip when you bundle',
    actionText: 'Book now',
    ...createHandlers(
      'https://www.priceline.com/partner/v2/packages-florida',
      '3'
    )
  }
] as const
